import { UfoIcon } from '@/assets/icons'
import React from 'react'
import { Centered, StateActions, StateMessage, StateTitle } from './PublicPageState.styles'

interface PublicUnavailableStateProps {
	/** e.g. "Trip Unavailable". */
	title: string
	/** Per-page wording, e.g. "This trip doesn't exist or has been set to private…". */
	message: string
	/** A way out for a visitor who has one, e.g. a link back to their trips. */
	action?: React.ReactNode
}

/**
 * The UFO "unavailable / private" state shared by every public share page: an
 * unknown code, a deleted trip, and a master-switch-off trip all land here (the
 * endpoints answer 404 for each, deliberately indistinguishable).
 */
const PublicUnavailableState: React.FC<PublicUnavailableStateProps> = ({ title, message, action }) => (
	<Centered>
		<UfoIcon width={250} height={250} />
		<StateTitle>{title}</StateTitle>
		<StateMessage>{message}</StateMessage>
		{action && <StateActions>{action}</StateActions>}
	</Centered>
)

export default PublicUnavailableState
